export default "__VITE_ASSET__DCBwYHv4__"